// extracted by mini-css-extract-plugin
export default {"wrapper":"jx-z","viewport":"kx-z","container":"lx-z","slide":"mx-z"};